import { MutableRefObject, useEffect } from 'react'
import type { Message } from '../types'

// ============================================
// useTranscriptScroll — auto-scroll + ref sync
// ============================================
// Owns the two transcript-driven effects that previously lived inline
// in VoiceBotPanel.tsx:
//
//   1. After every transcript update, scroll the container to the
//      bottom on the next animation frame so new messages are visible.
//   2. Keep `transcriptMessagesRef.current` aligned with the latest
//      transcript array so callbacks can read the freshest history
//      without re-subscribing.
//
// Both effects depend only on `transcript`, so extracting them is safe
// and does not change rendering or callback semantics.

export const useTranscriptScroll = (
  transcript: Message[],
  transcriptRef: MutableRefObject<HTMLDivElement | null>,
  transcriptMessagesRef: MutableRefObject<Message[]>
): void => {
  useEffect(() => {
    if (transcriptRef.current) {
      requestAnimationFrame(() => {
        if (transcriptRef.current) {
          transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight
        }
      })
    }
  }, [transcript, transcriptRef])

  useEffect(() => {
    transcriptMessagesRef.current = transcript
  }, [transcript, transcriptMessagesRef])
}
